import {
  buildSchema, graphql
} from 'graphql'
// ------------------------------------
// Constants
// ------------------------------------
export const QUERIES_LIST_FETCHED = 'QUERIES_LIST_FETCHED'
export const GET_QUERIES_LIST_START = 'GET_QUERIES_LIST_START'
export const OPEN_RECORD_START = 'OPEN_RECORD_START'
export const OPEN_RECORD = 'OPEN_RECORD'
export const RETURN_INITIAL_STATE = 'RETURN_INITIAL_STATE'

export const actions = {
  getQueriesList,
  retrieveRecords,
  openRecord,
  matchDocs,
  returnInitialRecordsState
}
// ------------------------------------
// Actions
// ------------------------------------
export function getQueriesList (pageIndex) {
  const schema = buildSchema(`
    type QueryOption {
      value: String
      label: String
    }
    type Query {
      queriesList: [QueryOption]
    }
  `)
  const query = `{
    queriesList {
      value
      label
    }
  }`
  const root = {
    queriesList: () => {
      switch (pageIndex) {
        case 'CL':
          return queriesListCL
      }
    }
  }
  return (dispatch) => {
    dispatch({ type: GET_QUERIES_LIST_START })
    return graphql(schema, query, root).then(result => {
      if (result) {
        dispatch({
          type: QUERIES_LIST_FETCHED,
          payload: {
            json: result.data.queriesList,
            page: pageIndex
          }
        })
      }
    })
  }
}

export function retrieveRecords (page, type) {
  const schema = qrapgSchema
  const query = graphQuery(page, type)
  const root = {
    queryRecords: () => {
      return queryRecords
    }
  }
  return (dispatch) => {
    graphql(schema, query, root).then(result => {
      if (result) {
        dispatch({
          type: RETURN_INITIAL_STATE,
          payload: {
            page
          }
        })
        dispatch({ type: OPEN_RECORD_START })
        setTimeout(() => {
          dispatch({
            type: OPEN_RECORD,
            payload: {
              json: result.data.queryRecords,
              recordIndex: 0,
              page: page
            }
          })
        }, 500)
      }
    })
  }
}

export function openRecord (page, recordIndex) {
  return (dispatch) => {
    dispatch({
      type: RETURN_INITIAL_STATE,
      payload: {
        page
      }
    })
    dispatch({ type: OPEN_RECORD_START })
    setTimeout(() => {
      dispatch({
        type: OPEN_RECORD,
        payload: {
          json: queryRecords,
          recordIndex: recordIndex,
          page: page
        }
      })
    }, 500)
  }
}

export function matchDocs (docs, data) {
  let resultedDocs = {
    0: {
      textValues: {
        urlIdDocs: '',
        urlDescription: ''
      },
      radio: {
        docsType: ''
      }
    }
  }
  docs.map(item => {
    if (data.otherDocs[item.id] === undefined) {
      resultedDocs[item.id] = {
        textValues: {
          urlIdDocs: item.url,
          urlDescription: item.urlDescription
        },
        radio: {
          docsType: item.docsType
        }
      }
    }
  })
  return resultedDocs
}

export function returnInitialRecordsState (page) {
  return (dispatch) => {
    dispatch({
      type: RETURN_INITIAL_STATE,
      payload: {
        page
      }
    })
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
export const queriesActionHandler = (state, action) => {
  return {
    ...state,
    isFetchingData: false,
    renderData: {
      ...state.renderData,
      queriesList: action.payload.json
    },
    formDataValue: {
      ...state.formDataValue,
      [action.payload.page]: {
        ...state.formDataValue[action.payload.page],
        queriesList: action.payload.json
      }
    }
  }
}

function graphQuery (page) {
  switch (page) {
    case 'LNRR':
      return `{
      queryRecords {
        reviewRows {
          rowID
          team
          assignedBy
          assignedDate
          reviewedBy
          reviewedDate
          type
          isReviewed
        }
        recordInfo {
          legisID
          state
          billType
          billNumber
          session
          companion
          sponsor
          firstChecked
          version
          highlight
          url
          iderReviewed
        }
        recordSummary {
          summaryDate
          ssLegisPath
          summary
        }
        keywordRecords {
          team
          client
          subject
          keyword
          hits
          foundDate
          changedDate
          oldHits
        }
        otherDocs {
          url
          urlDescription
          docsType
          id
        }
        clients {
          client
          subject
          changedDate
          reviewer
        }
        notLoadedClients {
          client
          keywords
          team
          reviewedDate
          reviewer
        }
      }
    }`
    case 'CL':
      return `{
      queryRecords {
        recordInfo {
          legisID
          state
          billType
          billNumber
          session
          companion
          introDate
          actionDate
          oldLoadDate
          loadDate
          createDate
          historyUpdated
          createUserId
          lastUpdateId
          version
          highlight
          url
          history
          supplementalHistory
          remarks
        }
        keywordRecords {
          team
          client
          subject
          keyword
          hits
          foundDate
          changedDate
          oldHits
        }
        otherDocs {
          url
          urlDescription
          docsType
          id
        }
        recordSummary {
          summaryDate
          summaryView
          summaryArea
          rawSummaryDate
          rawSummaryArea
        }
        clientActions {
          clientId
          client
          clientUser
          action
          actionDetail
          email
          subject
          subjectDate
          createdBy
          createdByDate
          comment
        }
      }
    }`
  }
}
const qrapgSchema = buildSchema(`
  type KeywordRecord {
    team: Int
    client: String
    subject: String
    keyword: String
    hits: Int
    foundDate: String
    changedDate: String
    oldHits: Int
  }
  type RecordSummary {
    summaryDate: String
    ssLegisPath: String
    summary: String
    summaryView: String
    summaryArea: String
    rawSummaryDate: String
    rawSummaryArea: String
  }
  type RecordInfo {
    legisID: Int
    state: String
    billType: String
    billNumber: Int
    session: String
    companion: String
    sponsor: String
    firstChecked: String
    version: String
    highlight: String
    url: String
    iderReviewed: Boolean
    introDate: String
    actionDate: String
    oldLoadDate: String
    loadDate: String
    createDate: String
    historyUpdated: String
    createUserId: String
    lastUpdateId: String
    history: String
    supplementalHistory: String
    remarks: String
  }
  type ReviewRows {
    rowID: Int
    team: Int
    assignedBy: String
    assignedDate: String
    reviewedBy: String
    reviewedDate: String
    type: String
    isReviewed: Boolean
  }
  type Record {
    recordInfo: RecordInfo
    recordSummary: RecordSummary
    keywordRecords: [KeywordRecord]
    reviewRows: [ReviewRows]
    otherDocs: [OtherDocs]
    clients: [Clients]
    notLoadedClients: [NotLoadedClients]
    clientActions: [ClientActions]
    sponsorInfo: SponsorInfo
  }
  type OtherDocs {
    url: String
    urlDescription: String
    docsType: String
    id: Int
  }
  type Clients {
    client: String
    subject: String
    changedDate: String
    reviewer: String
  }
  type NotLoadedClients {
    client: String
    keywords: String
    team: Int
    reviewedDate: String
    reviewer: String
  }
  type ClientActions {
    clientId: Int
    client: String
    clientUser: String
    action: String
    actionDetail: String
    email: String
    subject: String
    subjectDate: String
    createdBy: String
    createdByDate: String
    comment: String
  }
  type SponsorInfo {
    unmatched: [Sponsors]
    lookupBills: [Sponsors]
  }
  type Sponsors {
    state: String
    type: String
    number: Int
    session: String
    stateRecord: String
    billText: String
    firstName: String
    lastName: String
    legislatorFN: String
    legislatorLN: String
    isLegislator: Boolean
    committee: String
  }
  type Query {
    queryRecords: [Record]
  }
`)

const queriesListLNR = [
  { value: 'allBy', label: 'All By State, Session, Bill Type' },
  { value: 'byBill', label: 'By Bill' },
  { value: 'byDay', label: 'By Day' },
  { value: 'byDayRange', label: 'By Day Range' },
  { value: 'byDayToTeam', label: 'By Day to Team' },
  { value: 'byDaysAndIDer', label: 'By Days and IDer' },
  { value: 'byKeywordWithoutClientSubj', label: 'By Keyword without client/subj' },
  { value: 'byKeywordClientNotInLegis', label: 'By Keyword/Client not in Legis' },
  { value: 'byWordInSummary', label: 'By Word in Summary' },
  { value: 'excludedResolutionsByDateRange', label: 'Excluded Resolutions By Date Range' },
  { value: 'excludedResolutionsNew', label: 'Excluded Resolutions NEW' },
  { value: 'iderUnreviewedBillTextDownloaded', label: 'IDer Unreviewed - bill text downloaded' },
  { value: 'iderUnreviewedBillTextNotDownloaded', label: 'IDer Unreviewed - bill text not downloaded' },
  { value: 'noKeywordsButInLegisByDate', label: 'No Keywords but in Legis by Date' },
  { value: 'reReviewedBillTextAfterRRDate', label: 'ReReview, Bill text after RR Date' },
  { value: 'searchReviewedNotLoadedSummaryKeyword', label: 'Search Reviewed Not Loaded Summary Keyword' },
  { value: 'teamReviewedByDayReviewer', label: 'Team Reviewed By Day, Reviewer' },
  { value: 'teamReviewedByDayReviewerLoaded', label: 'Team Reviewed By Day, Reviewer, Loaded' },
  { value: 'teamReviewedByDayReviewerNotLoaded', label: 'Team Reviewed By Day, Reviewer, NOT Loaded' },
  { value: 'teamReviewedByDayReviewerEnacted', label: 'Team Reviewed By Day,Reviewer,Enacted' },
  { value: 'teamReviewedByDayReviewerEnactedLoaded', label: 'Team Reviewed By Day,Reviewer,Enacted,Loaded' },
  { value: 'teamReviewedByDayReviewerEnactedNotLoaded', label: 'Team Reviewed By Day,Reviewer,Enacted,NOT Loaded' },
  { value: 'teamUserCustomKeywordQC', label: 'Team User/Custom Keyword QC' },
  { value: 'teamKeywordQC', label: 'Team Keyword QC' },
  { value: 'teamToReviewAmended', label: 'Team to Review~ Amended' },
  { value: 'teamToReviewAmendedResolutions', label: 'Team to Review~ Amended Resolutions' },
  { value: 'teamToReviewEnacted', label: 'Team to Review~ ENACTED' },
  { value: 'teamToReviewNew', label: 'Team to Review~ New' },
  { value: 'teamToReviewNewResolutions', label: 'Team to Review~ NEW Resolutions' }
]

const queriesListCL = [
  { value: 'all', label: 'All' },
  { value: 'allEverything', label: 'All - Everything' },
  { value: 'byLegisIdNumber', label: 'By Legis ID Number - For New Record Review' },
  { value: 'lookupBill', label: 'Lookup - Bill' },
  { value: 'lookupByTypeWithDums', label: 'Lookup - By Type With Dums' },
  { value: 'lookupByType', label: 'Lookup - By Type' },
  { value: 'lookupCarriedOverByType', label: 'Lookup - Carries Over By Type' },
  { value: 'lookupClientAutoloadedCreateDate', label: 'Lookup - Client AUTOLOADED and Create Date' },
  { value: 'lookupClientAutoloadedSummary', label: 'Lookup - Client AUTOLOADED w Client summary' },
  { value: 'lookupClientSubjWOClientSubjByDT', label: 'Lookup - Client Subj WO Client Subj by DT' },
  { value: 'lookupDeadByType', label: 'Lookup - Dead by Type' },
  { value: 'lookupEnactedByTypeLoadDate', label: 'Lookup - Enacted by Type Load Date' },
  { value: 'lookupEnactedByType', label: 'Lookup - Enacted By Type' },
  { value: 'lookupKeywordByType', label: 'Lookup - Keyword By Type' },
  { value: 'lookupPrefiledByType', label: 'Lookup - Prefiled By Type' },
  { value: 'lookupSponsorByType', label: 'Lookup - Sponsor By Type' },
  { value: 'lookupVetoedByType', label: 'Lookup - Vetoed By Type' },
  { value: 'maint1SponsorIncomp', label: 'Maint - 1 Sponsor Incomp W/urls - Update 1st' },
  { value: 'maint1aSponsorChangedFlag', label: 'Maint - 1a Sponsor Changed Flag' },
  { value: 'maint2BillTypeSponsorHonorific', label: 'Maint - 2 Bill Type and Sponsor Honorific' },
  { value: 'mgtByClientAddDateType', label: 'Mgt - By Client, Add date and Type' },
  { value: 'mgtByClientMissedLogAddDate', label: 'Mgt - By Client, SS Missed Log, AddDate' },
  { value: 'mgtByClientSubjectLaodDate', label: 'Mgt - By Client, Subject and Load Date' },
  { value: 'mgtByClientAddTeamDate', label: 'Mgt - By ClientAdd, Team, Date' },
  { value: 'mgtByClientDeleteTeamDate', label: 'Mgt - By ClientDelete,Team, Date' },
  { value: 'mgtByStaffClientSubjecrAddDate', label: 'Mgt - By Staff,Client, Subject Add Date' },
  { value: 'mgtByWebLogonidClientActionLog', label: 'Mgt - By Web Logonid Client action Log' },
  { value: 'mgtStaffMemberUpdateDate', label: 'Mgt - Staff Member and Update Date' },
  { value: 'mgtStaffClientSummEditingNew', label: 'Mgt - Staff/client Summ Editing-New 2/22' },
  { value: 'mgtCommNewDoneEditorTeamDate', label: 'Mgt Comm NEW-done,editor,team,date' },
  { value: 'mgtCommNewNotDoneNotReviewed', label: 'Mgt Comm NEW-not done, not reviewed' },
  { value: 'resolutions', label: 'Resolutions' },
  { value: 'summaryAHIPUpdates', label: 'Summary – AHIP Updates' },
  { value: 'summaryChangedByUserDate', label: 'Summary changed by user date' },
  { value: 'summaryClientTeamStateUpdateFlag', label: 'Summary Client Team State Update Flag' },
  { value: 'summaryGT900', label: 'SummaryGT900 Client Team State Update Flag' },
  { value: 'summaryLT150', label: 'SummaryLT150 Client Team State Update Flag' },
  { value: 'summaryRawChangedAfterZSummary', label: 'Summary-Raw Changed after Z summary' },
  { value: 'teamAliveBillsState', label: 'Team - Alive Bills - State' },
  { value: 'teamAllState', label: 'Team - All - State' },
  { value: 'teamAllDUMBills', label: 'Team - All DUM bills' },
  { value: 'teamAmendmentCheck', label: 'Team - Amendment Check' },
  { value: 'teamA1NewManagementComments', label: 'Team A1 NEW Management Comments' },
  { value: 'teamA1NewMngtCommAnsweredQuestion', label: 'Team A1 NEW Mngt Comm Answered Question' },
  { value: 'teamA5CheckCompanions', label: 'Team A5 Check Companions' },
  { value: 'teamB3AmendSumm', label: 'Team B3 Amend Summ' },
  { value: 'teamB7WithoutAnySubjects', label: 'Team B7 Without Any Subjects' },
]

export const queryRecords = [
  {
    reviewRows: [
      {
        rowID: 61,
        team: 6,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: '',
        reviewedDate: '',
        type: 'legis',
        isReviewed: false
      },
      {
        rowID: 6,
        team: 5,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: 'qwe',
        reviewedDate: '12/14/18 12:10:00 AM',
        type: 'legis',
        isReviewed: true
      },
      {
        rowID: 15,
        team: 2,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: 'ryraey',
        reviewedDate: 'ajipo79tju',
        type: 'legisAmend',
        isReviewed: true
      },
      {
        rowID: 10,
        team: 1,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: 'qwe',
        reviewedDate: '12/14/18 12:10:00 AM',
        type: 'legisEnacted',
        isReviewed: true
      }
    ],
    recordInfo: {
      legisID: 1,
      state: 'AK',
      billType: 'SB',
      billNumber: '12345',
      session: '2019-2020',
      companion: 'companion',
      sponsor: 'sponsor',
      firstChecked: '12/14/18 12:10:00 AM',
      version: 'http://www.legislature.state.al.us/aliswww/default.aspx',
      highlight: 'http://www.legislature.state.al.us/aliswww/default.aspx',
      url: 'http://alisondb.legislature.state.al.us/alison/default.aspx',
      iderReviewed: false,
      introDate: '12/14/18 12:00:00 AM',
      actionDate: '12/14/18 12:00:00 AM',
      oldLoadDate: '12/14/18 12:00:00 AM',
      loadDate: '12/14/18 12:00:00 AM',
      createDate: '12/14/18 12:00:00 AM',
      historyUpdated: '12/14/18 12:00:00 AM',
      createUserId: 'AutoLoad',
      lastUpdateId: 'sa',
      history: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur, aut, quibusdam! Cumque delectus' +
      'dignissimos, dolor earum est illo ipsa, ipsam iure nisi officiis perferendis perspiciatis reprehenderit' +
      'repudiandae, sapiente sed voluptas!',
      supplementalHistory: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur, aut, quibusdam!' +
      'dignissimos, dolor earum est illo ipsa, ipsam iure nisi officiis perferendis perspiciatis reprehenderit' +
      'repudiandae, sapiente sed voluptas!',
      remarks: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur, aut, quibusdam! Cumque delectus' +
      'dignissimos, dolor earum est illo ipsa, ipsam iure nisi officiis perferendis perspiciatis reprehenderit' +
      'repudiandae, sapiente sed voluptas!'
    },
    recordSummary: {
      summaryDate: '12/14/18 12:10:00 AM',
      ssLegisPath: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
      summary: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur, aut, quibusdam! Cumque delectus' +
      'dignissimos, dolor earum est illo ipsa, ipsam iure nisi officiis perferendis perspiciatis reprehenderit' +
      'repudiandae, sapiente sed voluptas!',
      summaryView: 'f',
      summaryArea: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae officiis vel numquam eius. ' +
      'Culpa voluptatum fugit corporis quam modi ea. Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam ' +
      'provident eligendi dolore fuga quia qui sequi laboriosam exercitationem consequuntur, unde porro pariatur ' +
      'suscipit aliquid distinctio, illum dolores quidem neque! Nam.',
      rawSummaryDate: '12/14/18 12:10:00 AM',
      rawSummaryArea: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae officiis vel ' +
      'numquam eius. Culpa voluptatum fugit corporis quam modi ea. Lorem ipsum dolor sit amet consectetur adi' +
      ' elit. Totam provident eligendi dolore fuga quia qui sequi laboriosam exercitationem consequuntur, ' +
      'suscipit aliquid distinctio, illum dolores quidem neque! Nam.'
    },
    keywordRecords: [
      {
        team: 1,
        client: 'client 1',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 9,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 123
      },
      {
        team: 6,
        client: 'client 2',
        subject: 'Air',
        keyword: 'Bool: bicycle safety',
        hits: 8,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 59
      },
      {
        team: 5,
        client: 'client 3',
        subject: 'Automobile',
        keyword: 'Bool: bicycle safety',
        hits: 5,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 5
      },
      {
        team: 3,
        client: 'client 4',
        subject: 'Design',
        keyword: 'Bool: bicycle safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 10
      },
      {
        team: 6,
        client: 'client 5',
        subject: 'Procedure and Enforcement',
        keyword: 'bicycle safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 34
      },
      {
        team: 9,
        client: 'client 6',
        subject: 'Banking',
        keyword: 'Bool:  safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 56
      },
      {
        team: 7,
        client: 'client 7',
        subject: 'Banking',
        keyword: 'Bool:  safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 56
      }
    ],
    otherDocs: [
      {
        url: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
        urlDescription: 'descr',
        docsType: 'summary',
        id: 1
      },
      {
        url: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
        urlDescription: 'descr',
        docsType: 'analysis',
        id: 2
      }
    ],
    clients: [
      {
        client: 'client1',
        subject: 'subject name',
        changedDate: '12/14/2018 12:20:00 AM',
        reviewer: 'reviewer'
      },
      {
        client: 'client11',
        subject: 'subject name',
        changedDate: '12/14/2018 12:20:00 AM',
        reviewer: 'reviewer'
      },
      {
        client: 'client12',
        subject: 'subject name',
        changedDate: '12/14/2018 12:20:00 AM',
        reviewer: 'reviewer'
      },
      {
        client: 'client13',
        subject: 'subject name',
        changedDate: '12/14/2018 12:20:00 AM',
        reviewer: 'reviewer'
      }
    ],
    notLoadedClients: [
      {
        client: 'financesos',
        keywords: 'Vendor Contracting',
        team: 6,
        reviewedDate: '',
        reviewer: ''
      },
      {
        client: 'healthsos',
        keywords: 'Corporations::Outsourcing',
        team: 3,
        reviewedDate: '1/8/2019 7:59:00 AM',
        reviewer: 'JChargel'
      }
    ],
    clientActions: [
      {
        clientId: 1,
        client: 'a',
        clientUser: 'aa',
        action: 'aaa',
        actionDetail: 'aaa action',
        email: 'aaa@gmail.com',
        subject: 'aaa subject',
        subjectDate: 'aa date',
        createdBy: 'by aa',
        createdByDate: 'created date',
        comment: 'aa comment here'
      },
      {
        clientId: 2,
        client: 'b',
        clientUser: 'bb',
        action: 'bbb',
        actionDetail: 'bbb action',
        email: 'bbb@gmail.com',
        subject: 'bbb subject',
        subjectDate: 'bb date',
        createdBy: 'by bb',
        createdByDate: 'bb date cr',
        comment: 'bb comment here'
      },
      {
        clientId: 3,
        client: 'c',
        clientUser: 'cc',
        action: 'ccc',
        actionDetail: 'ccc action',
        email: 'ccc@gmail.com',
        subject: 'cc subject',
        subjectDate: 'cc subject date',
        createdBy: 'by cc',
        createdByDate: 'cc created date',
        comment: 'cc comment here'
      }
    ],
    sponsorInfo: {
      lookupBills: [{
        state: 'AK',
        type: 'HCONRES',
        number: 101,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: 'first name',
        lastName: 'Agriculture',
        isLegislator: false,
        committee: ''
      }],
      unmatched: [{
        state: 'AK',
        type: 'HCONRES',
        number: 101,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Agriculture',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 102,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Agriculture',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 103,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Agriculture',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 104,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Agriculture',
        isLegislator: false,
        committee: ''
      }]
    }
  },
  {
    reviewRows: [
      {
        rowID: 16,
        team: 5,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 18:10:00 AM',
        reviewedBy: '',
        reviewedDate: '',
        type: 'legis',
        isReviewed: false
      },
      {
        rowID: 60,
        team: 7,
        assignedBy: 'Keywords',
        assignedDate: '12/8/18 12:10:00 AM',
        reviewedBy: 'qwe',
        reviewedDate: '12/9/18 12:10:00 AM',
        type: 'legis',
        isReviewed: true
      },
      {
        rowID: 51,
        team: 1,
        assignedBy: 'Keywords',
        assignedDate: '12/4/18 12:10:00 AM',
        reviewedBy: 'ryraey',
        reviewedDate: '12/4/18 12:10:00 AM',
        type: 'legisAmend',
        isReviewed: true
      },
      {
        rowID: 79,
        team: 3,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: 'qwe',
        reviewedDate: '12/14/18 12:10:00 AM',
        type: 'legisEnacted',
        isReviewed: true
      }
    ],
    recordInfo: {
      legisId: 2,
      state: 'AL',
      billType: 'SB',
      billNumber: '512345',
      session: '2019-2020',
      companion: 'companion',
      sponsor: 'sponsor',
      firstChecked: '12/14/18 12:10:00 AM',
      version: 'http://www.legislature.state.al.us/aliswww/default.aspx',
      highlight: 'http://www.legislature.state.al.us/aliswww/default.aspx',
      url: 'http://alisondb.legislature.state.al.us/alison/default.aspx',
      iderReviewed: false
    },
    recordSummary: {
      summaryDate: '12/14/18 12:10:00 AM',
      ssLegisPath: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
      summary: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur, aut, quibusdam! Cumque delectus' +
      'dignissimos, dolor earum est illo ipsa, ipsam iure nisi officiis perferendis perspiciatis reprehenderit' +
      'repudiandae, sapiente sed voluptas!'
    },
    keywordRecords: [
      {
        team: 2,
        client: 'client 1',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 9,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 123
      },
      {
        team: 1,
        client: 'client 2',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 8,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 59
      },
      {
        team: 3,
        client: 'client 3',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 5,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 5
      },
      {
        team: 5,
        client: 'client 4',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 10
      },
      {
        team: 9,
        client: 'client 4',
        subject: 'Safety',
        keyword: 'bicycle safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 34
      },
      {
        team: 6,
        client: 'client 5',
        subject: 'Insurance - Safety',
        keyword: 'Bool:  safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 56
      }
    ],
    otherDocs: [
      {
        url: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
        urlDescription: 'descr',
        docsType: 'summary',
        id: 3
      }
    ],
    clients: [
      {
        client: 'client2',
        subject: 'subject name',
        changedDate: '12/14/2018 12:20:00 AM',
        reviewer: 'reviewer'
      }
    ],
    notLoadedClients: [
      {
        client: 'financesos',
        keywords: 'Vendor Contracting',
        team: 6,
        reviewedDate: '',
        reviewer: ''
      },
      {
        client: 'healthsos',
        keywords: 'Corporations::Outsourcing',
        team: 3,
        reviewedDate: '1/8/2019 7:59:00 AM',
        reviewer: 'JChargel'
      }
    ],
    sponsorInfo: {
      lookupBills: [{
        state: 'AK',
        type: 'HCONRES',
        number: 101,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: 'first name',
        lastName: 'Agriculture',
        isLegislator: false,
        committee: ''
      }],
      unmatched: [{
        state: 'AK',
        type: 'HCONRES',
        number: 101,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Farm',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 102,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Farm',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 103,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Farm',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 104,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Farm',
        isLegislator: false,
        committee: ''
      }]
    }
  },
  {
    reviewRows: [
      {
        rowID: 611,
        team: 9,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: '',
        reviewedDate: '',
        type: 'legis',
        isReviewed: false
      },
      {
        rowID: 68,
        team: 6,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: 'qwe',
        reviewedDate: '12/14/18 12:10:00 AM',
        type: 'legis',
        isReviewed: true
      },
      {
        rowID: 115,
        team: 3,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: 'ryraey',
        reviewedDate: 'ajipo79tju',
        type: 'legisAmend',
        isReviewed: true
      },
      {
        rowID: 110,
        team: 2,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: 'qwe',
        reviewedDate: '12/14/18 12:10:00 AM',
        type: 'legisEnacted',
        isReviewed: true
      }
    ],
    recordInfo: {
      legisId: 3,
      state: 'AR',
      billType: 'SB',
      billNumber: '12345',
      session: '2019-2020',
      companion: 'companion',
      sponsor: 'sponsor',
      firstChecked: '12/14/18 12:10:00 AM',
      version: 'http://www.legislature.state.al.us/aliswww/default.aspx',
      highlight: 'http://www.legislature.state.al.us/aliswww/default.aspx',
      url: 'http://alisondb.legislature.state.al.us/alison/default.aspx',
      iderReviewed: false
    },
    recordSummary: {
      summaryDate: '12/14/18 12:10:00 AM',
      ssLegisPath: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
      summary: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur, aut, quibusdam! Cumque delectus' +
      'dignissimos, dolor earum est illo ipsa, ipsam iure nisi officiis perferendis perspiciatis reprehenderit' +
      'repudiandae, sapiente sed voluptas!'
    },
    keywordRecords: [
      {
        team: 1,
        client: 'client 1',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 9,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 123
      },
      {
        team: 2,
        client: 'client 2',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 8,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 59
      },
      {
        team: 5,
        client: 'client 3',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 5,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 5
      },
      {
        team: 3,
        client: 'client 4',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 10
      },
      {
        team: 6,
        client: 'client 5',
        subject: 'Safety',
        keyword: 'bicycle safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 34
      },
      {
        team: 9,
        client: 'client 6',
        subject: 'Insurance - Safety',
        keyword: 'Bool:  safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 56
      }
    ],
    otherDocs: [
      {
        url: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
        urlDescription: 'descr',
        docsType: 'summary',
        id: 4
      },
      {
        url: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
        urlDescription: 'descr',
        docsType: 'summary',
        id: 5
      }
    ],
    clients: [
      {
        client: 'client3',
        subject: 'subject name',
        changedDate: '12/14/2018 12:20:00 AM',
        reviewer: 'reviewer'
      }
    ],
    notLoadedClients: [
      {
        client: 'financesos',
        keywords: 'Vendor Contracting',
        team: 6,
        reviewedDate: '',
        reviewer: ''
      },
      {
        client: 'healthsos',
        keywords: 'Corporations::Outsourcing',
        team: 3,
        reviewedDate: '1/8/2019 7:59:00 AM',
        reviewer: 'JChargel'
      }
    ],
    sponsorInfo: {
      lookupBills: [{
        state: 'AK',
        type: 'HCONRES',
        number: 101,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: 'first name',
        lastName: 'Agriculture',
        isLegislator: false,
        committee: ''
      }],
      unmatched: [{
        state: 'AK',
        type: 'HCONRES',
        number: 101,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Committee',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 102,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Committee',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 103,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Committee',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 104,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Committee',
        isLegislator: false,
        committee: ''
      }]
    }
  },
  {
    reviewRows: [
      {
        rowID: 161,
        team: 7,
        assignedBy: 'Keywords',
        assignedDate: 'record 4',
        reviewedBy: '',
        reviewedDate: '',
        type: 'legis',
        isReviewed: false
      },
      {
        rowID: 8,
        team: 8,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: 'qwe',
        reviewedDate: '12/14/18 12:10:00 AM',
        type: 'legis',
        isReviewed: true
      },
      {
        rowID: 615,
        team: 6,
        assignedBy: 'Keywords',
        assignedDate: 'la-la-la',
        reviewedBy: 'ryraey',
        reviewedDate: 'ajipo79tju',
        type: 'legisAmend',
        isReviewed: true
      },
      {
        rowID: 101,
        team: 1,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: 'qwe',
        reviewedDate: '12/14/18 12:10:00 AM',
        type: 'legisEnacted',
        isReviewed: true
      }
    ],
    recordInfo: {
      legisId: 4,
      state: 'AZ',
      billType: 'SB',
      billNumber: '12345',
      session: '2019-2020',
      companion: 'companion',
      sponsor: 'sponsor',
      firstChecked: '12/14/18 12:10:00 AM',
      version: 'http://www.legislature.state.al.us/aliswww/default.aspx',
      highlight: 'http://www.legislature.state.al.us/aliswww/default.aspx',
      url: 'http://alisondb.legislature.state.al.us/alison/default.aspx',
      iderReviewed: false
    },
    recordSummary: {
      summaryDate: '12/14/18 12:10:00 AM',
      ssLegisPath: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
      summary: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur, aut, quibusdam! Cumque delectus' +
      'dignissimos, dolor earum est illo ipsa, ipsam iure nisi officiis perferendis perspiciatis reprehenderit' +
      'repudiandae, sapiente sed voluptas!'
    },
    keywordRecords: [
      {
        team: 1,
        client: 'client 1',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 9,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 123
      },
      {
        team: 2,
        client: 'client 2',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 8,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 59
      },
      {
        team: 5,
        client: 'client 3',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 5,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 5
      },
      {
        team: 3,
        client: 'client 4',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 10
      },
      {
        team: 6,
        client: 'client 5',
        subject: 'Safety',
        keyword: 'bicycle safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 34
      },
      {
        team: 9,
        client: 'client 6',
        subject: 'Insurance - Safety',
        keyword: 'Bool:  safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 56
      }
    ],
    otherDocs: [
      {
        url: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
        urlDescription: 'descr',
        docsType: 'summary',
        id: 6
      }
    ],
    clients: [
      {
        client: 'client4',
        subject: 'subject name',
        changedDate: '12/14/2018 12:20:00 AM',
        reviewer: 'reviewer'
      }
    ],
    notLoadedClients: [
      {
        client: 'financesos',
        keywords: 'Vendor Contracting',
        team: 6,
        reviewedDate: '',
        reviewer: ''
      },
      {
        client: 'healthsos',
        keywords: 'Corporations::Outsourcing',
        team: 3,
        reviewedDate: '1/8/2019 7:59:00 AM',
        reviewer: 'JChargel'
      }
    ],
    sponsorInfo: {
      lookupBills: [{
        state: 'AK',
        type: 'HCONRES',
        number: 101,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: 'first name',
        lastName: 'Agriculture',
        isLegislator: false,
        committee: ''
      }],
      unmatched: [{
        state: 'AK',
        type: 'HCONRES',
        number: 101,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Last name',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 102,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Last name',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 103,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Last name',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 104,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: '',
        lastName: 'Last name',
        isLegislator: false,
        committee: ''
      }]
    }
  },
  {
    reviewRows: [
      {
        rowID: 651,
        team: 5,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: '',
        reviewedDate: '',
        type: 'legis',
        isReviewed: false
      },
      {
        rowID: 76,
        team: 7,
        assignedBy: 'Keywords',
        assignedDate: 'bla-bla-bla',
        reviewedBy: 'qwe',
        reviewedDate: '12/14/18 12:10:00 AM',
        type: 'legis',
        isReviewed: true
      },
      {
        rowID: 195,
        team: 3,
        assignedBy: 'Keywords',
        assignedDate: '12/14/18 12:10:00 AM',
        reviewedBy: 'ryraey',
        reviewedDate: 'ajipo79tju',
        type: 'legisAmend',
        isReviewed: true
      },
      {
        rowID: 160,
        team: 3,
        assignedBy: 'Keywords',
        assignedDate: 'la-la-ka',
        reviewedBy: 'qwe',
        reviewedDate: '12/14/18 12:10:00 AM',
        type: 'legisEnacted',
        isReviewed: true
      }
    ],
    recordInfo: {
      legisId: 5,
      state: 'CA',
      billType: 'SB',
      billNumber: '12345',
      session: '2019-2020',
      companion: 'companion',
      sponsor: 'sponsor',
      firstChecked: '12/14/18 12:10:00 AM',
      version: 'http://www.legislature.state.al.us/aliswww/default.aspx',
      highlight: 'http://www.legislature.state.al.us/aliswww/default.aspx',
      url: 'http://alisondb.legislature.state.al.us/alison/default.aspx',
      iderReviewed: false
    },
    recordSummary: {
      summaryDate: '12/14/18 12:10:00 AM',
      ssLegisPath: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
      summary: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur, aut, quibusdam! Cumque delectus' +
      'dignissimos, dolor earum est illo ipsa, ipsam iure nisi officiis perferendis perspiciatis reprehenderit' +
      'repudiandae, sapiente sed voluptas!'
    },
    keywordRecords: [
      {
        team: 1,
        client: 'client 1',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 9,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 123
      },
      {
        team: 2,
        client: 'client 2',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 8,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 59
      },
      {
        team: 5,
        client: 'client 3',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 5,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 5
      },
      {
        team: 3,
        client: 'client 4',
        subject: 'Insurance - Safety',
        keyword: 'Bool: bicycle safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 10
      },
      {
        team: 6,
        client: 'client 5',
        subject: 'Safety',
        keyword: 'bicycle safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 34
      },
      {
        team: 9,
        client: 'client 6',
        subject: 'Insurance - Safety',
        keyword: 'Bool:  safety',
        hits: 3,
        foundDate: '12/14/18 12:10:00 AM',
        changedDate: '12/14/18 12:10:00 AM',
        oldHits: 56
      }
    ],
    otherDocs: [
      {
        url: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
        urlDescription: 'descr',
        docsType: 'summary',
        id: 7
      },
      {
        url: 'http://www.statescape.com/resources/legislative/legislature-links.aspx',
        urlDescription: 'descr',
        docsType: 'summary',
        id: 8
      }
    ],
    clients: [
      {
        client: 'client5',
        subject: 'subject name',
        changedDate: '12/14/2018 12:20:00 AM',
        reviewer: 'reviewer'
      }
    ],
    notLoadedClients: [
      {
        client: 'financesos',
        keywords: 'Vendor Contracting',
        team: 6,
        reviewedDate: '',
        reviewer: ''
      },
      {
        client: 'healthsos',
        keywords: 'Corporations::Outsourcing',
        team: 3,
        reviewedDate: '1/8/2019 7:59:00 AM',
        reviewer: 'JChargel'
      }
    ],
    sponsorInfo: {
      unmatched: [{
        state: 'AK',
        type: 'HCONRES',
        number: 101,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: 'first name',
        lastName: 'Agriculture',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 102,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: 'first name',
        lastName: 'Agriculture',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 103,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: 'first name',
        lastName: 'Agriculture',
        isLegislator: false,
        committee: ''
      },
      {
        state: 'AK',
        type: 'HCONRES',
        number: 104,
        session: '2019-2020',
        stateRecord: 'http://www.akleg.gov/basis/Bill/Detail/31?Root=HB%20%20%201',
        billText: 'http://www.akleg.gov/basis/Bill/Text/31?Hsid=HB0001A',
        firstName: 'first name',
        lastName: 'Agriculture',
        isLegislator: false,
        committee: ''
      }]
    }
  }
]



// WEBPACK FOOTER //
// ./src/store/reducers/queriesFormData.js